import type { BookmarkToggleEvent } from 'shared/assets/types/Bookmark'

export default class FollowBookmark {
	private followBookmark: HTMLElement | null

	constructor() {
		this.followBookmark = document.querySelector('.followBookmark')
		this.onPending = this.onPending.bind(this)
		this.onToggle = this.onToggle.bind(this)

		this.toggleButton = this.toggleButton.bind(this)
	}

	init() {
		if (!this.followBookmark) return

		this.addEvent()
	}

	addEvent() {
		this.followBookmark?.addEventListener('click', this.onPending)
		document.addEventListener('BMK::TOGGLED', this.onToggle)
		document.addEventListener('BMK::STATUS-INIT-DONE', () => this.toggleButton(this.isEnabled))
	}

	/**
	 * Activate a loading state during the Bookmark call
	 */
	onPending() {
		this.followBookmark?.classList.add('isPending')
	}

	/**
	 * Callback for the custom event BMK::TOGGLED
	 * @param {CustomEventInit<BookmarkToggleEvent>} event
	 */
	onToggle(event: CustomEventInit<BookmarkToggleEvent>) {
		if (event.detail?.type === this.followBookmark?.getAttribute('data-bookmark-type')) {
			this.toggleButton(!!event.detail?.status)
		}
	}

	/**
	 * Toggles the button state.
	 * @param {boolean} isChecked
	 */
	toggleButton(isChecked: boolean) {
		this.followBookmark?.classList.remove('isPending')
		this.followBookmark?.setAttribute('aria-checked', String(isChecked))
	}

	/**
	 * Gets the enabled state.
	 * @returns {boolean}
	 */
	get isEnabled(): boolean {
		return this.followBookmark?.getAttribute('data-bookmark-status') === 'true'
	}
}
